export const updateQuizQuestion = (payload?: any) => ({
    type: "@saga/UPDATE_QUIZ_QUESTION",
    payload
});

